<div class="my-card p-4">
  <h4 class="primary-color mb-0">Andamento ragazzi per TL</h4>

  <ng-container *ngIf="!isEdit"> <hr class="mt-3" /></ng-container>

  <ng-container *ngIf="!isEdit">
    <div *ngIf="monitoringResponse; else loading">
      <nz-row [nzGutter]="24" nzAlign="middle" class="d-flex">
        <nz-col
          [nzLg]="{ span: 8, offset: 0 }"
          [nzMd]="{ span: 24, offset: 0 }"
          [nzSm]="{ span: 24, offset: 0 }"
          [nzXs]="{ span: 24, offset: 0 }"
          class="d-flex align-items-center"
          [ngClass]="isMobile ? 'justify-content-between' : ''">
          <button
            (click)="changeTab('team')"
            class="choice-btn btn rounded-pill d-flex align-items-center px-2 py-1 primary-color me-3">
            <mat-icon *ngIf="selectedTab === 'team'" class="me-1 small-icon"
              >done</mat-icon
            >
            Team
            <span class="badge bg-light text-dark ms-2">{{
              monitoringResponse?.totali_Team.Velocity
            }}</span>
          </button>

          <button
            (click)="changeTab('client')"
            class="choice-btn client btn rounded-pill d-flex align-items-center px-2 py-1 primary-color">
            <mat-icon *ngIf="selectedTab === 'client'" class="me-1 small-icon"
              >done</mat-icon
            >
            Cliente
            <span class="badge bg-light text-dark ms-2">{{
              monitoringResponse?.totali_Cliente.Velocity
            }}</span>
          </button>
        </nz-col>

        <nz-col
          [nzLg]="{ span: 12, offset: 4 }"
          [nzMd]="{ span: 24, offset: 0 }"
          [nzSm]="{ span: 24, offset: 0 }"
          [nzXs]="{ span: 24, offset: 0 }"
          class="d-flex align-items-center"
          [ngClass]="{
            'justify-content-end': isDesktop,
            'justify-content-between': isMobile || isTablet
          }">
          <div
            class="d-flex align-items-center"
            [ngClass]="{
              'flex-column': isMobile,
              'me-3': isDesktop
            }">
            <p class="fw-bold mb-0">Data inizio</p>
            <nz-date-picker
              nzFormat="dd/MM/yyyy"
              [(ngModel)]="startDate"
              (ngModelChange)="onChange()"
              [nzDisabledDate]="
                configureValideRangeForStartDate
              "></nz-date-picker>
          </div>

          <div
            class="d-flex align-items-center"
            [ngClass]="{ 'flex-column': isMobile }">
            <p class="mb-0 fw-bold">Data fine</p>
            <nz-date-picker
              nzFormat="dd/MM/yyyy"
              [(ngModel)]="endDate"
              (ngModelChange)="onChange()"
              [nzDisabledDate]="
                configureValideRangeForEndDate
              "></nz-date-picker>
          </div>
        </nz-col>
      </nz-row>
      <app-monitoring-table
        [isMonitoringPage]="false"
        [responseData]="currentPageDatafirst"
        [responseTotal]="totFirstTable"
        [pageSize]="pageSizefirst"
        [totUserForPage]="totalItemsfirst"
        (pageChange)="onPageChange($event)"></app-monitoring-table>
    </div>
  </ng-container>
  <ng-template #loading>
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 8 }"></nz-skeleton>
  </ng-template>
</div>
